import banner from "../../../courses/module-1/img2.png";

const modulo2_pt = {
  courseId: "finanzas-personales",
  id: "modulo-2", // ⚠️ Mantém o mesmo ID
  title: "📘 MÓDULO 2: Orçamento Inteligente",
  estimatedDuration: "2 horas",
  format: "Leitura + atividade prática + entrega do orçamento pessoal",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos do módulo",
      content: [
        "Entender o que é um orçamento e por que ele é essencial para controlar seu dinheiro com consciência.",
        "Diferenciar tipos de gastos e identificar para onde o seu dinheiro está indo.",
        "Criar seu próprio orçamento mensal usando ferramentas simples e uma planilha-modelo.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Leitura principal",
      title: "📖 Leitura principal: Como montar um orçamento?",
      content: [
        {
          type: "paragraph",
          text: "📌 O que é um orçamento?",
        },
        {
          type: "paragraph",
          text: "Um orçamento é uma ferramenta que te ajuda a planejar seus ingressos e gastos.",
        },
        {
          type: "paragraph",
          text: "É como um mapa: mostra quanto você pode gastar e em quê, ajudando a evitar surpresas no fim do mês.",
        },
        {
          type: "list",
          items: ["Em resumo: Orçar é decidir antes de gastar."],
        },
        {
          type: "paragraph",
          text: "🧠 Por que isso é importante?",
        },
        {
          type: "list",
          items: [
            "Evita sustos desagradáveis (“como assim já acabou meu dinheiro?”).",
            "Te ajuda a alcançar metas (viajar, economizar, comprar algo importante).",
            "Dá clareza e controle sobre sua vida financeira.",
          ],
        },
      ],
    },
    // {
    //   id: "importancia",
    //   navLabel: "Por que é importante?",
    //   title: "🧠 Por que é importante?",
    //   content: [
    //     {
    //       type: "list",
    //       items: [
    //         "Evita surpresas desagradáveis ('Como assim, já fiquei sem dinheiro?!').",
    //         "Ajuda você a alcançar metas (como viajar, economizar ou comprar algo importante).",
    //         "Dá controle e clareza sobre sua vida financeira.",
    //       ],
    //     },
    //   ],
    // },
    {
      id: "tipos-gastos",
      navLabel: "Tipos de gastos",
      title: "💸 Tipos de gastos: entenda cada um",
      content: [
        {
          type: "paragraph",
          text: "Para montar um orçamento realista, é essencial saber classificar seus gastos:",
        },
        {
          type: "table",
          headers: ["Tipo de gasto", "O que é?", "Exemplos"],
          rows: [
            [
              "Fixos",
              "Acontecem todo mês, sem falhar.",
              "Aluguel, plano de celular, transporte",
            ],
            [
              "Variáveis",
              "Mudam conforme o mês.",
              "Lanches, saídas, gasolina, delivery",
            ],
            [
              "Discricionários",
              "São desejos, não necessidades.",
              "Roupas, cafés especiais, gadgets, cinema",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "Dica: Não é sobre cortar tudo que você gosta — é sobre gastar com intenção.",
        },
      ],
    },
    {
      id: "ejemplo-practico",
      navLabel: "Exemplo prático",
      title: "📊 Exemplo prático: sua planilha de orçamento em ação",
      content: [
        {
          type: "link",
          href: "https://docs.google.com/spreadsheets/d/1FBMOSfjV1ePG5mUFOwbdvzxE3S_1nfqXG4F_ouuKtVQ/edit?usp=sharing",
          text: "🔗 Acesse a planilha modelo aqui:",
        },
        {
          type: "list",
          items: [
            "Campo para registrar ingressos mensais",
            "Lista de gastos organizados por tipo: Fixas, Variáveis, Aportes de poupança",
            "Espaço para anotar seu aporte de poupança mensal",
            "Cálculos automáticos de: Total de ingressos, Total de gastos, Total poupado, Saldo final (quanto realmente sobra)",
          ],
        },
      ],
    },
    {
      id: "replicar-tabla",
      navLabel: "Como replicar",
      title: "🛠 Como replicar esta planilha?",
      content: [
        {
          type: "paragraph",
          text: "Use Google Sheets ou Excel. Passo a passo:",
        },
        {
          type: "paragraph",
          text: "1. Crie duas colunas:",
        },
        {
          type: "list",
          items: [
            "A: Categoria (ex.: “Ingresso: Bolsa”, “Gasto fixo: Aluguel”)",
            "B: Valor mensal",
          ],
        },
        {
          type: "paragraph",
          text: "2. Classifique seus gastos conforme as categorias deste módulo.",
        },
        {
          type: "paragraph",
          text: "3. Use fórmulas como:",
        },
        {
          type: "list",
          items: ["Somar ingressos: =SOMA(B2:B5)"],
        },
        {
          type: "list",
          items: ["Somar gastos: =SOMA(B6:B15)"],
        },
        {
          type: "list",
          items: ["Registrar poupança mensal: =SOMA(B16:B17)"],
        },
        {
          type: "paragraph",
          text: "Coloque manualmente em B16 ou use:",
        },
        {
          type: "list",
          items: ["Calcular saldo real: =(B17+B18)-B19"],
        },
        {
          type: "paragraph",
          text: "4. Aplique cores, bordas e negrito para facilitar a visualização.",
        },
      ],
    },
    {
      id: "ejemplo-real",
      navLabel: "Exemplo real",
      title: "💬 Exemplo real: orçamento de um estudante",
      content: [
        {
          type: "paragraph",
          text: "Andrea tem 20 anos e estuda Psicologia na PUC.",
        },
        {
          type: "paragraph",
          text: "Ingressos:",
        },
        {
          type: "list",
          items: [
            "R$ 1.600 de bolsa",
            "R$ 800 de trabalho meio período",
            "Total: R$ 2.400",
          ],
        },
        {
          type: "paragraph",
          text: "Gastos:",
        },
        {
          type: "list",
          items: [
            "Aluguel compartilhado: R$ 1.000",
            "Transporte: R$ 300",
            "Alimentação: R$ 500",
            "Discricionários (Netflix, rolês, snacks): R$ 400",
            "Total: R$ 2.200",
          ],
        },
        {
          type: "paragraph",
          text: "Poupança planejada: R$ 100",
        },
        {
          type: "paragraph",
          text: "Saldo disponível: R$ 300",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade prática",
      title: "🧠 Atividade prática",
      content: [
        {
          type: "paragraph",
          text: "Monte seu orçamento mensal, usando a planilha de exemplo como base.",
        },
        {
          type: "paragraph",
          text: "Inclua:",
        },
        {
          type: "list",
          items: [
            "Ingressos",
            "Gastos por categoria",
            "Poupança",
            "Saldo final",
            "Meta financeira (ex.: economizar X, cortar Y, etc.)",
          ],
        },
      ],
    },
    {
      id: "lecturas-recomendadas",
      navLabel: "Leituras recomendadas",
      title: "📚 Leituras recomendadas",
      content: [
        {
          type: "paragraph",
          text: "“Guia para fazer seu primeiro orçamento” – CONDUSEF",
        },
        {
          type: "paragraph",
          text: "“Pra onde vai meu dinheiro?” – Blog Pequeño Cerdo Capitalista",
        },
        {
          type: "paragraph",
          text: "TikTok @primopobre – Dicas rápidas de investimento",
        },
      ],
    },
    {
      id: "evaluacion",
      navLabel: "Avaliação rápida",
      title: "📝 Avaliação rápida",
      content: [
        {
          type: "paragraph",
          text: "Quais você já concluiu?",
        },
        {
          type: "list",
          items: [
            "Identificar seus rendimentos reais",
            "Descobri gastos ocultos ou desnecessários",
            "Classificar corretamente suas despesas",
            "Montei minha tabela (em planilha ou papel)",
            "Defini uma meta financeira",
          ],
        },
      ],
    },
    {
      id: "bibliografia",
      navLabel: "Bibliografia",
      title: "📚 Bibliografia para aprofundar",
      content: [
        "Sofía Macías – “Pequeno Porco Capitalista”",
        "Harv Eker – “Os Segredos da Mente Milionária”",
        "CONDUSEF – “Educação financeira básica para jovens”",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: ["“Quem controla seu orçamento, controla sua liberdade.”"],
    },
  ],
};

export default modulo2_pt;
